import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d2b1cbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-lg-3 p-4 border-left-aside" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = { class: "symbol symbol-35px symbol-circle" }
const _hoisted_4 = { class: "ms-5" }
const _hoisted_5 = { class: "fs-5 fw-bolder text-gray-900 text-hover-primary mb-2" }
const _hoisted_6 = { class: "fw-bold text-gray-400 d-block" }
const _hoisted_7 = { class: "d-flex flex-column fv-row mt-7" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "col-md-6 fv-row mt-8 position-relative" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = {
  key: 1,
  class: "row g-9 mb-1 mt-2"
}
const _hoisted_12 = { class: "fv-row position-relative" }
const _hoisted_13 = { class: "fs-6 fw-bold mb-2 d-block" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "icon_page",
    src: "/svg/icon_page.svg"
  })
], -1))
const _hoisted_16 = { class: "ms-5" }
const _hoisted_17 = { class: "fw-bold text-gray-800" }
const _hoisted_18 = { class: "fv-row position-relative" }
const _hoisted_19 = { class: "fs-6 fw-bold mb-2 d-block" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-20px" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Icon_Section",
    src: "/svg/Icon_Section.svg"
  })
], -1))
const _hoisted_22 = { class: "ms-5" }
const _hoisted_23 = { class: "fw-bold text-gray-800" }
const _hoisted_24 = {
  key: 2,
  class: "d-flex flex-column fv-row mt-7"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "Dates", -1))
const _hoisted_26 = { class: "d-flex flex-column fv-row mt-7" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "d-flex flex-column fv-row mt-7" }
const _hoisted_29 = { class: "mb-6 d-flex justify-content-between align-items-center" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Development ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "svg/github/add.svg",
  alt: "add-icon"
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "development-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_BoxEdit = _resolveComponent("BoxEdit")!
  const _component_ProgerssBar = _resolveComponent("ProgerssBar")!
  const _component_TicketDevelopmentCard = _resolveComponent("TicketDevelopmentCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.assignedUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass([`bg-light-success text-success`, "symbol-label fw-bold"])
            }, _toDisplayString(_ctx.assignedUser.firstName?.charAt(0)), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.assignedUser.firstName) + " " + _toDisplayString(_ctx.assignedUser.lastName), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.assignedUser.email), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.translate("skills")), 1),
      _createVNode(_component_el_select, {
        modelValue: _ctx.skillsLocal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.skillsLocal) = $event)),
        multiple: "",
        filterable: "",
        "allow-create": "",
        "default-first-option": "",
        placeholder: "Choose skills for your target",
        class: "mw-100"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillsFullList, (skill) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: skill.id,
              label: skill.name,
              value: skill.name,
              class: "fw-bold text-gray-800"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(skill.name), 1)
              ]),
              _: 2
            }, 1032, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.translate("type")), 1),
      _createElementVNode("p", {
        class: "fs-6 mt-2 text-gray-700",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateShow')))
      }, _toDisplayString(_ctx.type?.name), 1)
    ]),
    (_ctx.type !== 'Page')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate("relatesToPage")), 1),
            _createVNode(_component_el_tooltip, {
              class: "item",
              effect: "dark",
              content: "Click to Edit",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: "fs-6 mt-2 text-gray-700",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('updateShowPages')))
                }, _toDisplayString(_ctx.relatesPage), 1)
              ]),
              _: 1
            }),
            (_ctx.show === 7)
              ? (_openBlock(), _createBlock(_component_BoxEdit, {
                  key: 0,
                  title: _ctx.translate('relatesToPage'),
                  onConfirme: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('confirmationPages'))),
                  onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('resetShowPages'))),
                  class: "box-edit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.relatesPageLocal,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.relatesPageLocal) = $event)),
                      placeholder: "Select a relates",
                      name: "relates",
                      as: "select",
                      disabled: _ctx.type !== 'Section'
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: `${page.id} - ${page.title}`,
                            value: `${page.id} - ${page.title}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(page.id) + " - " + _toDisplayString(page.title), 1)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate("relatesToSection")), 1),
            _createVNode(_component_el_tooltip, {
              class: "item",
              effect: "dark",
              content: "Click to Edit",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: "fs-6 mt-2 text-gray-700",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('updateShowSection')))
                }, _toDisplayString(_ctx.relatesSection), 1)
              ]),
              _: 1
            }),
            (_ctx.show === 8)
              ? (_openBlock(), _createBlock(_component_BoxEdit, {
                  key: 0,
                  title: _ctx.translate('relatesToSection'),
                  onConfirme: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('confirmationSection'))),
                  onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('resetShowSection'))),
                  class: "box-edit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.relatesSectionLocal,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.relatesSectionLocal) = $event)),
                      placeholder: "Select a relates",
                      name: "relates",
                      as: "select",
                      disabled: _ctx.type !== 'Action'
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: `${section.id} - ${section.title}`,
                            value: `${section.id} - ${section.title}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(section.id) + " - " + _toDisplayString(section.title), 1)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.createdAt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("p", null, "Created at: " + _toDisplayString(_ctx.createdAt.toDateString()), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.translate("timeTracking")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeTrackingItems, (timeTrackingItem) => {
        return (_openBlock(), _createElementBlock("div", {
          key: timeTrackingItem.label,
          class: "mb-4"
        }, [
          _createVNode(_component_ProgerssBar, {
            percentage: parseInt(timeTrackingItem.value),
            title: timeTrackingItem.label,
            color: timeTrackingItem.color,
            label: timeTrackingItem.time,
            "text-inside": false
          }, null, 8, ["percentage", "title", "color", "label"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("h4", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("span", {
          class: "cursor-pointer",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showModel('KTCreateNewBranche')))
        }, _hoisted_32)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_TicketDevelopmentCard, {
          onClick: () => _ctx.showModel('KTAllBranches'),
          "item-count": 3,
          title: 'Branches',
          src: 'svg/github/branche.svg',
          alt: 'img-branch'
        }, null, 8, ["onClick", "src"]),
        _createVNode(_component_TicketDevelopmentCard, {
          onClick: () => _ctx.showModel('KTAllCommits'),
          "item-count": 5,
          title: 'Commits',
          src: 'svg/github/commit.svg',
          alt: 'img-commit',
          description: 'Latest 5 hours ago',
          background: '#d7f9ef',
          "color-count": '#0bb783'
        }, null, 8, ["onClick", "src"]),
        _createVNode(_component_TicketDevelopmentCard, {
          onClick: () => _ctx.showModel('KTAllPull'),
          "item-count": 8,
          title: 'Pull requests',
          src: 'svg/github/pull.svg',
          alt: 'img-pull',
          description: 'Due in 2 Days',
          background: '#e1e9ff',
          "color-count": '#6993ff'
        }, null, 8, ["onClick", "src"])
      ])
    ])
  ]))
}